/**
 * Manages navigation context for analytics tracking.
 * Stores context globally and makes it available to all analytics events.
 */
class NavigationContextManager {
  constructor() {
    this.context = {};
  }

  setContext(context) {
    this.context = { ...context };
  }

  getContext() {
    return { ...this.context };
  }

  clearContext() {
    this.context = {};
  }
}

export default new NavigationContextManager();
